import { render } from "./modal-banner.html?vue&type=template&id=0cc4b2a4&scoped=true&ts=true"
import script from "./modal-banner.vue?vue&type=script&lang=ts"
export * from "./modal-banner.vue?vue&type=script&lang=ts"

import "./modal-banner.scss?vue&type=style&index=0&id=0cc4b2a4&scoped=true&lang=scss"

import exportComponent from "/builds/customer/line/line-web-loyalty/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc4b2a4"]])

export default __exports__